import React from 'react'
import { Bars3Icon } from '@heroicons/react/24/outline'

interface MobileMenuButtonProps {
  onClick: () => void
  className?: string
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ 
  onClick, 
  className = '' 
}) => {
  return (
    <button
      onClick={onClick}
      className={`mobile-menu-button lg:hidden ${className}`}
      aria-label="Open navigation menu"
    >
      <Bars3Icon className="w-6 h-6" />
    </button>
  )
}